import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/openBets.css';
import {
    getDecimalSeparator,
    getFormattedCurrency,
    getText,
    reverseFormatNumber,
    usingNonDecimalCurrency
} from '../../../helpers/localization';
import OpenBetRacing from '../modules/racing/components/openBetRacing';
import OpenBetFootball from '../modules/football/components/openBetFootball';
import OpenBetMatchday from '../modules/matchday/components/openBetMatchday';
import OpenBetFirstDown from '../modules/firstDown/components/openBetFirstDown';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import {
    AMERICAN_FOOTBALL_MODULE, BASEBALL_MODULE,
    BASKETBALL_MODULE, CRICKET_MODULE,
    ENABLED,
    FIRST_DOWN_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    RACING_MODULE, TENNIS_MODULE,
    XXX,
    ALERT_NOTIFICATION
} from '../../../constants/identifiers';
import Accordion from '../components/accordion';
import {roundNumber} from '../../../helpers/mathFunctions';
import {getOdd} from '../modules/racing/helpers/betFunctions';
import {areBetsToPlaceStakeLimitsValid, isBetValid, placeBets, isAccaBetPresentInBetSlip, scaleNumber} from '../helpers/betHelpers';
import {calculateEachWayValues} from '../../../helpers/eachWayBetHelpers';
import {
    clearOpenBetsList,
    doQuickFillBets,
    removeClosedEventsOpenBets,
    toggleQuickFill,
    updateOpenBetMultiplier,
    updateOpenBetStake,
    autofocusQuickFill,
    disableQuickFill,
    updateUIStateTimer,
    updateUIState
} from '../actions/openBetsActions';
import Keyboard from "../components/keyboard";
import {hasVirtualKeyboard} from "../../../helpers/layoutHelpers";
import device from "current-device";
import OpenBetBasketball from "../modules/basketball/components/openBetBasketball";
import OpenBetAmericanFootball from "../modules/americanFootball/components/openBetAmericanFootball";
import {collapseOpenBetAccordion} from './../../../actions/betSlipActions';
import {BASE_VALUE} from "../../../constants/chips";
import {OPERATOR} from "../../../constants/operator";
import {getPotentialReturn, getRoundedOdds} from '../modules/matchday/helpers/matchdayHelper';
import AccaBonusMessageHeader from '../modules/matchday/components/accaBonusMessageHeader';
import {openCloseRealityCheckModal} from '../../../actions/realityCheckModalAction';
import {openCloseDemoplayNotificationModal} from '../../../actions/demoplayNotificationModalAction';
import OpenBetCricket from "../modules/cricket/components/openBetCricket";
import OpenBetTennis from "../modules/tennis/components/openBetTennis";
import OpenBetBaseball from '../modules/baseball/components/openBetBaseball';
import {reportUIBusyState} from '../../../ui-modules/sports-book/helpers/betHelpers';
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers';
import { BET_LIMITS } from '../../../constants/betLimits';
import {isMinMaxStakeOverriden} from '../../../helpers/helperFunctions.js';

/* global BMS*/

let scrollIntoView = false;

//needed to give the user the chance to click on the place Bets button when the keyboard is opened
let closeKeyboardTimeout;

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsList: state.vpp.openBetsList,
        betsCommitting: state.vpp.betsCommitting,
        betsCommitted: state.vpp.betsCommitted,
        betsFailedBeingCommitted: state.vpp.betsFailedBeingCommitted,
        games: state.vpp.games,
        showVirtualKeyboard: state.vpp.showVirtualKeyboard,
        collapsedOpenBetAccordions: state.vpp.collapsedOpenBetAccordions,
        playerBalance: state.vpp.playerBalance,
        quickFillStake: state.vpp.quickFillStake,
        quickFillBoxChecked: state.vpp.quickFillBoxChecked,
        quickFillBoxDisabled: state.vpp.quickFillBoxDisabled,
        systemLanguage: state.vpp.systemLanguage,
        quickFillAutoFocusEnabled: state.vpp.quickFillAutoFocusEnabled,
        accaBetAutoFocusEnabled: state.vpp.accaBetAutoFocusEnabled,
        busyStateTimeoutId: state.vpp.busyStateTimeoutId,
        isUserInterfaceBusy: state.vpp.isUserInterfaceBusy
    };
};

class OpenBets extends Component {

    constructor(props) {
        super(props);
        this.quickFillStakeBox = React.createRef();
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            openBetsList: storeData.vpp.openBetsList,
            betsCommitting: storeData.vpp.betsCommitting,
            betsCommitted: storeData.vpp.betsCommitted,
            betsFailedBeingCommitted: storeData.vpp.betsFailedBeingCommitted,
            games: storeData.vpp.games,
            isKeyboardOpened: true,
            bet: undefined,
            selectedInputElementId: undefined,
            lastFocusedBetStake: undefined,
            collapsedOpenBetAccordions: storeData.vpp.collapsedOpenBetAccordions,
            quickFillStake: storeData.vpp.quickFillStake,
            quickFillBoxChecked: storeData.vpp.quickFillBoxChecked,
            playerBalance: storeData.vpp.playerBalance,
            quickFillBoxDisabled: storeData.vpp.quickFillBoxDisabled,
            systemLanguage: storeData.vpp.systemLanguage,
            quickFillAutoFocusEnabled: storeData.vpp.quickFillAutoFocusEnabled,
            accaBetAutoFocusEnabled: storeData.vpp.accaBetAutoFocusEnabled,
            busyStateTimeoutId: storeData.vpp.busyStateTimeoutId,
            isUserInterfaceBusy: storeData.vpp.isUserInterfaceBusy
        };
    }

    componentDidMount(){
          if(OPERATOR.quickBetFillEnabled === true &&
            OPERATOR.quickFillAutoFocusEnabled === true &&
            this.props.store.getState().vpp.quickFillAutoFocusEnabled === undefined &&
            this.props.store.getState().vpp.quickFillBoxChecked === false){
            if(isAccaBetPresentInBetSlip(this.props.store.getState().vpp.openBetsList)){
                this.props.store.dispatch(disableQuickFill(true));
            }else{
                this.props.store.dispatch(autofocusQuickFill(true));
            }
          }

          setTimeout(() => {
            this.setState({
                ...this.state,
                isKeyboardOpened: true,
                quickFillAutoFocusEnabled: true
            })
          },1000
        );
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    openBetsList: storeData.vpp.openBetsList,
                    betsCommitting: storeData.vpp.betsCommitting,
                    betsCommitted: storeData.vpp.betsCommitted,
                    betsFailedBeingCommitted: storeData.vpp.betsFailedBeingCommitted,
                    games: storeData.vpp.games,
                    showVirtualKeyboard: storeData.vpp.showVirtualKeyboard,
                    collapsedOpenBetAccordions: storeData.vpp.collapsedOpenBetAccordions,
                    playerBalance: storeData.vpp.playerBalance,
                    quickFillStake: storeData.vpp.quickFillStake,
                    quickFillBoxChecked: storeData.vpp.quickFillBoxChecked,
                    quickFillBoxDisabled: storeData.vpp.quickFillBoxDisabled,
                    systemLanguage: storeData.vpp.systemLanguage,
                    quickFillAutoFocusEnabled: storeData.vpp.quickFillAutoFocusEnabled,
                    accaBetAutoFocusEnabled: storeData.vpp.accaBetAutoFocusEnabled,
                    busyStateTimeoutId: storeData.vpp.busyStateTimeoutId,
                    isUserInterfaceBusy: storeData.vpp.isUserInterfaceBusy
                }
            );
        }
    }

    componentWillUnmount() {
        if (closeKeyboardTimeout)
        clearTimeout(closeKeyboardTimeout); // prevent closeKeyboardTimeout from running after component is unmounted
    }

    _placeBets(totalStake) {
        let isTimeToShowLoading = !!this.state.betsCommitting;
        let isTimeToShowSuccess = !!this.state.betsCommitted;
        let isTimeToShowError = !!this.state.betsFailedBeingCommitted;
        let canPlaceBets = !isTimeToShowLoading && !isTimeToShowSuccess && !isTimeToShowError;

        let betsToPlace = this.props.store.getState().vpp.openBetsList.filter((bt) => Number(bt.stake) > 0);
        if (canPlaceBets && betsToPlace.length > 0 && areBetsToPlaceStakeLimitsValid(this.props.store, betsToPlace)) {
            if (process.env.NODE_ENV !== 'development') {
                if (BMS && BMS.authentication && !BMS.authentication.isPlayerLogged) {
                    BMS.error(getText('INFO_NOTIFICATION', this.props.store), getText('AUTHENTICATION_REQUIRED', this.props.store));
                    return;
                }
            }
            this._validateAndPlaceBets(totalStake, betsToPlace);
            this.setState({
                ...this.state,
                isKeyboardOpened: false
            });
        }
    }

    _toggleAccordion(gameCategory) {
        this.props.store.dispatch(collapseOpenBetAccordion(gameCategory))
    }

    _validateAndPlaceBets(totalStake, betsToPlace) {
        let totalStakeInMinorCurrency = totalStake * BASE_VALUE;
        if (OPERATOR.rcMaxTotalStake > 0 && totalStakeInMinorCurrency >= OPERATOR.rcMaxTotalStake) {
            this.props.store.dispatch(openCloseRealityCheckModal(betsToPlace));
        } else if (OPERATOR.rcMinTotalStake > 0 && totalStakeInMinorCurrency < OPERATOR.rcMinTotalStake) {
            window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1', true,
                        [getFormattedCurrency(this.props.store, Number(scaleNumber(OPERATOR.rcMinTotalStake, this.props.store)))],true,null,null);
        } else if (OPERATOR.demoplayNotificationEnabled && this.props.store.getState().vpp.systemCurrency === XXX) {
            this.props.store.dispatch(openCloseDemoplayNotificationModal(betsToPlace));
        } else {
            placeBets(betsToPlace, this.props.store);
        }
    }

    updateInputValue(quickFillStake) {
        if (/^(\.|,)+/.test(quickFillStake)) {
            quickFillStake = "0" + quickFillStake;
        }

        let category = this.getCategoryForQuickFill();
        if (isBetValid(quickFillStake, this.props.store,category)) {
            this.props.store.dispatch(
                doQuickFillBets(
                    quickFillStake,
                    process.env.NODE_ENV !== "development" &&
                    BMS &&
                    BMS.authentication &&
                    BMS.authentication.isPlayerLogged &&
                    this.state.playerBalance
                        ? this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                        : 2,
                    this.props.store.getState().vpp.systemLanguage,
                    this.props.store.getState().vpp.systemCurrency
                )
            );
        }
    }

    formatInputValue(currInputValue, id) {
        //the currInputValue is required for long press, when context menu is triggered, it will put on the input box the value of the currInputValue instead of the formated one

        currInputValue = currInputValue.replace(
            getDecimalSeparator(this.props.store),
            "."
        );
        if (currInputValue !== "" && !isNaN(currInputValue)) {
            let storeData = this.props.store.getState();
            let systemLanguage = storeData.vpp.systemLanguage;
            let systemCurrency = storeData.vpp.systemCurrency;
            if (
                this.props.store != undefined &&
                usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)
            ) {
                currInputValue = this.adjustInputValueToBaseIfNoDecimalPlaceEntered(
                    currInputValue,
                    systemCurrency
                );
            }
            currInputValue = getFormattedCurrency(
                this.props.store,
                currInputValue,
                2,
                systemLanguage,
                systemCurrency,
                false,
                true
            );
            //this is required to handle countries with commas as decimal separators
            this.updateInputValue(currInputValue);
        }
    }

    handleKeyPress(evt) {
        //accept only numbers, (dots and commas, if decimal currency)
        let storeData = this.props.store.getState();
        let systemCurrency = storeData.vpp.systemCurrency;
        var regex = usingNonDecimalCurrency(systemCurrency)
            ? /^(\d)$/
            : getDecimalSeparator(this.props.store) === "."
                ? /^\d{0,100}(?:\.\d{0,2})?$/
                : /^\d{0,100}(?:\,\d{0,2})?$/;
        if (!regex.test(evt.key)) evt.preventDefault();
    }

    _preventRoolbackToPreviousAmount(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    render() {
        let gameCategoriesOpenBets;
        let isEmpty = true;
        let isPossibleToCalculatePotentialReturns = true;
        let totalStake = 0;
        let totalPotentialReturns = 0;
        let gameCatgories;
        if (this.props.store.getState().vpp.games !== undefined && this.state.openBetsList.length > 0) {
            gameCatgories = [...new Set(this.props.store.getState().vpp.games.map(game => game.gameCategory))];
            gameCategoriesOpenBets = gameCatgories.map((gameCategory, gameIndex) => {
                let eventsOfGivenCategory = this.state.openBetsList.filter((betSelection) => betSelection.bets[0].game.gameCategory === gameCategory);
                eventsOfGivenCategory.sort((a, b) => a.bets[0].event.eventTimeDate - b.bets[0].event.eventTimeDate || a.bets.length - b.bets.length);
                return eventsOfGivenCategory.map((betSelection, betSelectionIndex) => {
                    isEmpty = false;
                    if (betSelection.stake) {
                        betSelection.stake = betSelection.stake.replace(',', '.');
                    }
                    if (Number(betSelection.stake)) {
                        if (this.props.store != undefined && usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            let stakeVal = ('' + betSelection.stake).replace(getDecimalSeparator(this.props.store), '');
                            totalStake += Number(stakeVal);
                        } else {
                            totalStake += (Number(betSelection.stake) * Number(betSelection.multiplier ? betSelection.multiplier : 1));
                        }
                    }
                    let openBetCard = null;
                    let isFocusEnabled = (OPERATOR.quickBetFillEnabled && OPERATOR.quickFillAutoFocusEnabled) ?
                        (this.state.quickFillAutoFocusEnabled !== undefined && this.state.openBetsList.length === 1 )
                         : (this.state.openBetsList.length === 1)
                    if (betSelection.bets[0].event.eventType !== undefined) {
                        switch (getModuleFromEventType(betSelection.bets[0].event.eventType)) {
                            case RACING_MODULE:
                                let odd = getOdd(betSelection);
                                if (odd === undefined || odd === '') {
                                    isPossibleToCalculatePotentialReturns = false;
                                }


                                // special case fo EW (double the stake in total stake and add 1/4 of the odd to total potential return)
                                if (betSelection.bets[0].externalRefId !== undefined && isPossibleToCalculatePotentialReturns) {

                                    let stake = Number(betSelection.stake);
                                    let ewValues = calculateEachWayValues(stake, odd, betSelection.bets[0].event.eachWayRatio);

                                    totalStake += stake;
                                    totalPotentialReturns += ewValues.potentialReturns;

                                    //promo logic
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns ;

                                } else if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(odd, betSelection.stake, 1, 0);
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }

                                openBetCard = (
                                    <OpenBetRacing
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case FOOTBALL_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    ;
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetFootball
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case BASKETBALL_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetBasketball
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case AMERICAN_FOOTBALL_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetAmericanFootball
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case FIRST_DOWN_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetFirstDown
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case MATCHDAY_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {

                                    let bonusPercentage = OPERATOR.accaBoostBonusEnabled ? JSON.parse(OPERATOR.accaBoostBonusPercentage)[betSelection.bets.length] : 0;
                                    let odds = getRoundedOdds(betSelection.bets, true);
                                    totalPotentialReturns += getPotentialReturn(odds, betSelection.stake, betSelection.multiplier, bonusPercentage);
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetMatchday
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                let bonusInfoFirst, bonusInfoLast = "";

                                let leagueDayMap = eventsOfGivenCategory.reduce(function (map, bet) {
                                    if (!map[bet.bets[0].event.leagueDay]) {
                                        map[bet.bets[0].event.leagueDay] = [];
                                    }
                                    map[bet.bets[0].event.leagueDay].push(bet);
                                    return map;
                                }, {});

                                let leagueDayBets = leagueDayMap[betSelection.bets[0].event.leagueDay];
                                let accaBet = leagueDayBets.find((bet) => bet.bets.length > 1);
                                let accaBetOdds = undefined;
                                if (accaBet !== undefined) {
                                    accaBetOdds = getRoundedOdds(accaBet.bets, true);
                                    accaBetOdds = isNaN(accaBetOdds) || accaBetOdds > OPERATOR.maxAccumulatorOdds ? 0.00 : accaBetOdds;
                                }
                                if (betSelection.bets[0].uniqueId === leagueDayBets[leagueDayBets.length - 1].bets[0].uniqueId && (accaBet === undefined || accaBetOdds > 0)) {
                                    let bonusInfo = <AccaBonusMessageHeader betSelection={betSelection}
                                                                            store={this.props.store}/>;
                                    bonusInfoFirst = betSelection.bets.length > 1 ? bonusInfo : '';
                                    bonusInfoLast = betSelection.bets.length == 1 ? bonusInfo : '';
                                }
                                openBetCard = (<Fragment
                                    key={betSelectionIndex}>{bonusInfoFirst}{openBetCard}{bonusInfoLast}</Fragment>)
                                break;
                            case CRICKET_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    ;
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetCricket
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case TENNIS_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    ;
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetTennis
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            case BASEBALL_MODULE:
                                if (Number(betSelection.stake) && isPossibleToCalculatePotentialReturns) {
                                    totalPotentialReturns += getPotentialReturn(betSelection.bets[0].market.odds, betSelection.stake, 1, 0);
                                    ;
                                    if (OPERATOR.promoToolEnabled && betSelection.promo === 'applied')
                                        totalPotentialReturns = totalPotentialReturns - Number(betSelection.stake);
                                }
                                openBetCard = (
                                    <OpenBetBaseball
                                        key={betSelection.bets[0].uniqueId}
                                        index={gameIndex + '_' + betSelectionIndex}
                                        store={this.props.store}
                                        betSelection={betSelection}
                                        isEnabled={isFocusEnabled}
                                        openBetFocusCallback={this.isOpenBetFocused.bind(this)}/>
                                );
                                break;
                            default:
                                openBetCard = (<div></div>);
                                break;
                        }
                    }

                    return openBetCard;
                });
            });
        }

        let gameCategoriesOpenBetsUI;
        if (isEmpty) {
            gameCategoriesOpenBetsUI = (<div className={style.noBetsText}>{getText('NO_BETS', this.props.store)}</div>);
        } else {

            gameCategoriesOpenBetsUI = gameCategoriesOpenBets.map((gameCategoryOpenBets, index) => {
                if (gameCategoryOpenBets.length > 0) {
                    let isExpanded = !this.state.collapsedOpenBetAccordions.some((gameCategory) => gameCategory === gameCatgories[index])
                    let content = <div>{gameCategoryOpenBets}</div>;
                    return <Accordion
                        key={index}
                        id={'game_accordion_' + index}
                        store={this.props.store}
                        content={content}
                        onClick={this._toggleAccordion.bind(this)}
                        isExpanded={isExpanded}
                        label={getText('betSlip_' + gameCatgories[index], this.props.store)}
                        collapseKey={gameCatgories[index]}/>;
                }
                return null;
            });
        }

        if (!isPossibleToCalculatePotentialReturns) {
            totalPotentialReturns = getText('N_A', this.props.store);
        } else if (Number(totalPotentialReturns)) {
            totalPotentialReturns = roundNumber(totalPotentialReturns, 2);
        }

        let clearButton = null;
        if (this.state.openBetsList.length > 0) {
            clearButton = (
                <div
                    id={'remove_all_open_bets_button'}
                    className={`${style.clearButton}  ${OPERATOR.quickBetFillEnabled
                        ? style.clearButtonSmallDevice
                        : ''}`}
                    onClick={() => this.props.store.dispatch(clearOpenBetsList())}>{getText('REMOVE_ALL', this.props.store)}</div>
            );
        }

        let isTimeToShowLoading = !!this.state.betsCommitting;
        let isTimeToShowSuccess = !!this.state.betsCommitted;
        let isTimeToShowError = !!this.state.betsFailedBeingCommitted;

        let feedbackIndicator;
        if (isTimeToShowLoading) {
            feedbackIndicator = (
                <div className={style.circleLoaderContainer}>
                    <div className={style.circleLoader}/>
                </div>
            );
        } else if (isTimeToShowSuccess) {
            feedbackIndicator = (
                <div className={style.circleLoaderContainer}>
                    <div className={style.checkmarkContainer}>
                        <div className={style.checkmark}/>
                    </div>
                </div>
            );
        } else if (isTimeToShowError) {
            feedbackIndicator = (
                <div className={style.circleLoaderContainer}>
                    <div className={style.errormarkContainer}>
                        <div className={style.errormark}/>
                    </div>
                </div>
            );
        }

        let betsFromDisabledGames = this.state.openBetsList.filter(ob => {
            let game = this.state.games.find(g => g.channel === ob.bets[0].game.channel);
            return !game || game.state.toString() !== ENABLED
        });

        let stakeCount = 0;
        this.state.openBetsList.map(openBet => {
            if (openBet.stake > 0)
                stakeCount++;
            return stakeCount;
        });

        let placeButtonStyle = `${style.placeBetsButton} ${stakeCount > 0 && (OPERATOR.singleBetCommitEnabled ? stakeCount === 1 : stakeCount === this.state.openBetsList.length) ? style.flashingButton : ''} ${OPERATOR.quickBetFillEnabled ? style.placeBetsButtonSmallDevice : ''} `;

        let placeBetsButton = null;

        if (
            this.state.openBetsList.filter((ob) => ob.bets[0].hasExpired === true)
                .length > 0 ||
            betsFromDisabledGames.length > 0
        ) {
            placeBetsButton = (
                <div
                    id={"remove_closed_events_button"}
                    className={`${style.removeClosedEventsButton} ${OPERATOR.quickBetFillEnabled ? style.removeClosedEventsButtonSmallDevice : ''}`}
                    onClick={() =>
                        this.props.store.dispatch(removeClosedEventsOpenBets())
                    }
                >
                    {getText("REMOVE_CLOSED_EVENTS", this.props.store)}
                </div>
            );
        } else if (
            totalStake !== undefined &&
            totalStake !== 0 &&
            !isTimeToShowLoading &&
            !isTimeToShowSuccess &&
            !isTimeToShowError
        ) {
            let finalStake = totalStake;
            placeBetsButton = (
                <div
                    id={"place_bets_button"}
                    className={placeButtonStyle}
                    onClick={() => this._placeBets(finalStake)}
                >
                    {getText("PLACE_BETS", this.props.store)}
                </div>
            );
        } else {
            placeBetsButton = (
                <div
                    id={"place_bets_button"}
                    className={`${style.placeBetsButton} ${OPERATOR.quickBetFillEnabled ? style.placeBetsButtonSmallDevice : ''} ${style.disabled}  `}
                >
                    {isTimeToShowLoading || isTimeToShowSuccess || isTimeToShowError
                        ? feedbackIndicator
                        : getText("PLACE_BETS", this.props.store)}
                </div>
            );
        }

        // format stake totals to the right currency

        let systemCurrency = this.props.store.getState().vpp.systemCurrency;

        if (usingNonDecimalCurrency(systemCurrency)) {
            totalStake = getFormattedCurrency(this.props.store, "" + totalStake);
            totalPotentialReturns = Math.round(totalPotentialReturns);
            totalPotentialReturns = getFormattedCurrency(
                this.props.store,
                "" + totalPotentialReturns
            );
        } else {
            totalStake = getFormattedCurrency(this.props.store, totalStake);
            totalPotentialReturns = getFormattedCurrency(
                this.props.store,
                totalPotentialReturns
            );
        }

        // let showVirtualKeyboard = this.state.showVirtualKeyboard && this.state.isKeyboardOpened;
        let showVirtualKeyboard =
            hasVirtualKeyboard(this.props.store, device.desktop()) &&
            this.state.isKeyboardOpened &&
            (this.state.openBetsList.length ||
                this.props.store.getState().vpp.quickFillBoxChecked);

        let keyboard;
        if (showVirtualKeyboard) {
            keyboard = (
                <Keyboard
                    store={this.props.store}
                    lastFocusedBetStake={this.state.lastFocusedBetStake}
                    betFocused={this.state.betFocused}
                    selectedInputElementId={this.state.selectedInputElementId}
                    onKeyPress={(button, isLongTouch) =>
                        this.onKeyPress(button, isLongTouch)
                    }
                    ref={(ref) => (this.keyboard = ref)}
                />
            );
        }

        let TAX_NOTIFICATION_TEXT = getText(
            "TAX_NOTIFICATION_TEXT",
            this.props.store
        );

        let taxNotification =
            TAX_NOTIFICATION_TEXT != "none" ? (
                <div className={style.taxNotification}>{TAX_NOTIFICATION_TEXT}</div>
            ) : (
                ""
            );

        let quickFillBox = null;
        let quickFillCheckBox = null;
        let onChangeHandler = !showVirtualKeyboard ?
            (evt) => this.updateInputValue(evt.target.value) :
            undefined;
        let onInputChangeHandler = () => {
            this.props.store.dispatch(doQuickFillBets(this.state.quickFillStake,
                (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && this.state.playerBalance)
                    ? this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                    : 2,
                this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency));
        }

        let onChangeQuickFillBoxStatusHandler = () => {
            this.setState({
                ...this.state,
                isKeyboardOpened: true
            });
            this.props.store.dispatch(toggleQuickFill(!this.props.store.getState().vpp.quickFillBoxChecked));
        }

        quickFillCheckBox = (
            <div className={style.quickFillLabel}>
                <input className={style.quickFillCheckBox}
                       type="checkbox"
                       checked={this.props.store.getState().vpp.quickFillBoxChecked}
                       disabled={this.props.store.getState().vpp.quickFillBoxDisabled}
                       onChange={onChangeQuickFillBoxStatusHandler}
                />
                <span
                    className={`${(!this.props.store.getState().vpp.quickFillBoxDisabled) ? style.quickFillText : style.quickFillTextDisabled}`}>{getText('QUICK_FILL', this.props.store)}</span>
            </div>
        );
        quickFillBox = (this.props.store.getState().vpp.quickFillBoxChecked &&
            <div className={style.stake}>
                <input
                    className={style.quickStakeInput}
                    type={"text"}
                    id={"quickFillStakeBox"}
                    name="quickFillStakeBox"
                    value={this.props.store.getState().vpp.quickFillStake}
                    autoComplete='off'
                    readOnly={showVirtualKeyboard}
                    autoFocus={this.props.store.getState().vpp.quickFillBoxChecked}
                    onKeyPress={(evt) => {
                        this.handleKeyPress(evt)
                    }}
                    onBlur={(evt) =>{
                        this.props.store.dispatch(updateUIStateTimer(setTimeout(()=>this.publishStatus(false), 10000)));
                        this.formatInputValue(evt.target.value, "quickFillStakeBox")
                    }}
                    onContextMenu={(event) =>
                        this._preventRoolbackToPreviousAmount(event)
                    }
                    onChange={onChangeHandler}
                    onInput={onInputChangeHandler}
                    onFocus={() => {
                        this.isOpenBetFocused(
                            true,
                            undefined,
                            "quickFillStakeBox",
                            this.props.store.getState().vpp.quickFillStake
                        );
                    }}
                    ref={this.quickFillStakeBox}
                    inputMode="none"
                />
            </div>
        );

        return (
            <div className={style.mainContainer}>
                <div id='openBetsAccordions' className={`${style.openBetsAccordions} ${TAX_NOTIFICATION_TEXT != 'none'
                    ? style.openBetsAccordionsWithTaxText
                    : ''}`}>
                    {gameCategoriesOpenBetsUI}
                </div>
                {taxNotification}
                <div className={style.bottomContainer}>
                    <div className={style.infoContainer}>
                        <div
                            className={`${style.totalStakeContainer} ${OPERATOR.quickBetFillEnabled ? style.totalStakeContainerSmallDevice : ''}`}>
                            <div className={style.totalStakeText}>{getText('TOTAL_STAKE', this.props.store)}</div>
                            {!usingNonDecimalCurrency(systemCurrency) && OPERATOR.quickBetFillEnabled && quickFillCheckBox}
                            <div id={'total_stake_value'} className={style.totalStakeValue}>
                                {!this.props.store.getState().vpp.quickFillBoxChecked && totalStake.toString()}
                                {this.props.store.getState().vpp.quickFillBoxChecked && OPERATOR.quickBetFillEnabled && quickFillBox}
                            </div>
                        </div>
                        <div className={style.totalReturnsContainer}>
                            <div
                                className={style.totalReturnsText}>{getText('TOTAL_POTENTIAL_RETURNS', this.props.store)}</div>
                            <div id={'total_returns_value'}
                                 className={style.totalReturnsValue}>{totalPotentialReturns.toString()}</div>
                        </div>
                    </div>
                    <div className={style.buttonsContainer}>
                        {clearButton}
                        {placeBetsButton}
                    </div>
                </div>
                {keyboard}
            </div>
        );
    }

    componentDidUpdate() {
        //scroll input field if keyboard is on top of it
            if (scrollIntoView) {
                let inputElement = document.getElementById(this.state.selectedInputElementId);
                let viewElement = document.getElementById('openBetsAccordions');
                if (inputElement && viewElement && inputElement.id != 'quickFillStakeBox' &&
                    !this._isVisibleView(inputElement, viewElement)) {
                    document.getElementById(this.state.selectedInputElementId).scrollIntoView(false);
                    viewElement.scrollTop += 65;
                }
                scrollIntoView = false;
            }
            if(OPERATOR.quickBetFillEnabled && OPERATOR.quickFillAutoFocusEnabled && this.state.quickFillBoxChecked
                && !isAccaBetPresentInBetSlip(this.props.store.getState().vpp.openBetsList)
                && this.quickFillStakeBox.current != null && this.quickFillStakeBox.current != undefined){
                this.quickFillStakeBox.current.focus();
            }
    }

    _isVisibleView(inputElement, viewElement) {
        let rect = inputElement.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;

        let viewBoundaries = viewElement.getBoundingClientRect();

        // Only completely visible elements return true:
        let isVisible = (elemTop >= viewBoundaries.top) && (elemBottom <= viewBoundaries.bottom);
        return isVisible;
    }

    publishStatus(status){
        reportUIBusyState(status);
        this.props.store.dispatch(updateUIState(status));
    }

    isOpenBetFocused(isFocused, bet, inputElementId, lastFocusedBetStake) {
        if (isFocused) {
            scrollIntoView = true;
            clearTimeout(this.state.busyStateTimeoutId);
            this.props.store.dispatch(updateUIStateTimer(null));
            setTimeout(()=>!this.state.isUserInterfaceBusy && this.publishStatus(true), 100);
        }

        if (!isFocused) {
            this.props.store.dispatch(updateUIStateTimer(setTimeout(()=>this.publishStatus(false), 10000)));
            this.setState({
                ...this.state,
                lastFocusedBetStake: lastFocusedBetStake
            });

            //the timeout is required to delay the keyboard being closed
            closeKeyboardTimeout = setTimeout(() => this.setState({
                ...this.state,
                isKeyboardOpened: isFocused,
                betFocused: bet,
                selectedInputElementId: inputElementId,
            }), 300);

        } else {
            if (closeKeyboardTimeout)
                clearTimeout(closeKeyboardTimeout); // prevent keyboard from closing

            this.setState({
                ...this.state,
                isKeyboardOpened: isFocused,
                betFocused: bet,
                selectedInputElementId: inputElementId,
            });

        }


    }

    findMaxStakeAndCategory(minMaxStakeByCategory, categoryList) {
        let filteredCategoryList = minMaxStakeByCategory && categoryList && categoryList.length > 0 ? categoryList.filter(key => minMaxStakeByCategory.hasOwnProperty(key)) : [];
        if(filteredCategoryList === null || filteredCategoryList.length === 0){
            return {
                category: null,
                maxStake: null
            };
        }
        const maxKey = filteredCategoryList.reduce((maxKey, key) => minMaxStakeByCategory[key].maxStake > minMaxStakeByCategory[maxKey].maxStake ? key : maxKey, filteredCategoryList[0]);
        return {
            category: maxKey,
            maxStake: minMaxStakeByCategory[maxKey].maxStake
        };
    }

    collectUniqueChannels(data) {
        if (data == null) {
            return null;
        }

        const uniqueChannels = new Set();
        data.forEach(item => {
            item.bets.forEach(bet => {
                uniqueChannels.add(bet.game.channel);
            });
        });
        return [...uniqueChannels];
    }

    getCategoryForQuickFill() {
        let category = null;
        if(this.state.openBetsList && this.state.openBetsList.length > 0 && isMinMaxStakeOverriden()){
            let channels = this.collectUniqueChannels(this.state.openBetsList);
            const uniqueCategoryList = this.getCategories(channels);
            let minMaxStakeLimitByCategory = JSON.parse(BET_LIMITS.minMaxStakeLimitByCategory);
            let maxStakeAndCategory = this.findMaxStakeAndCategory(minMaxStakeLimitByCategory,uniqueCategoryList);
            let override = parseInt(maxStakeAndCategory.maxStake) > parseInt(BET_LIMITS.maxStake);
            category = override ? maxStakeAndCategory.category : null;
        }
        return category;
    }

    getCategories(channels){
        if(channels == null){
            return null;
        }

        return Array.from(new Set(channels.map(channel => getGameCategoryNameByChannel(this.props.store, channel))));
    }

    onKeyPress(button, isLongTouch = false) {
        if (
            this.state.betFocused !== undefined &&
            this.state.selectedInputElementId
        ) {
            let gameCategory = getGameCategoryNameByChannel(this.props.store, this.state.betFocused.bets[0].event.channel);
            if (button !== "OK") {
                let inputElement = document.getElementById(
                    this.state.selectedInputElementId
                );

                if (inputElement !== undefined && inputElement !== null) {
                    let inputValue = inputElement.value;
                    if (button === "{bksp}" && inputElement.value.length > 0) {
                        if (isLongTouch) {
                            inputValue = "";
                        } else {
                            inputValue = inputValue.substring(0, inputValue.length - 1);
                        }
                    } else if (
                        Number.isInteger(button) ||
                        (button === getDecimalSeparator(this.props.store) &&
                            !this.state.selectedInputElementId.includes("betmultiplierInput"))
                    ) {
                        // if(isLongTouch){
                        //   inputValue = button.toString();
                        // } else {
                        //   inputValue = inputValue + button;
                        // }
                        inputValue = inputValue + button;
                    } else if (button.charAt(0) === "+") {
                        //This is required for function keys, see Keyboard class
                        let systemLanguage = this.props.store.getState().vpp.systemLanguage;
                        inputValue = this.add(reverseFormatNumber(inputValue, systemLanguage), reverseFormatNumber(button, systemLanguage));
                    }
                    var currencyRegex =
                        "^\\" + getDecimalSeparator(this.props.store); //Regex Updated for bug PROD_VSB-6309
                    if (new RegExp(currencyRegex).test(inputValue)) {
                        inputValue = "0" + inputValue;
                    }

                    if (
                        button !== "{bksp}" &&
                        inputValue === getDecimalSeparator(this.props.store)
                    ) {
                        inputElement.value = inputValue;
                    } else if (
                        this.state.selectedInputElementId.includes("betmultiplierInput")
                    ) {
                        this.props.store.getState().vpp.quickFillStake = inputValue;
                    } else {
                        let isClearing = this.state.betFocused.stake ? this.state.betFocused.stake.length > inputValue.length : false;
                        if (isBetValid(inputValue, this.props.store, gameCategory) || isClearing) {
                        inputElement.value = inputValue;
                        this.props.store.dispatch(
                            updateOpenBetStake(
                                this.state.betFocused,
                                inputValue.replace(getDecimalSeparator(this.props.store), ".")));
                        }
                    }
                }
            } else {
                let inputElements = document.querySelectorAll(
                    'input[name="stakeInput"]:not([disabled])'
                );
                let indexOfInputSelected;

                for (const [index, el] of inputElements.entries()) {
                    if (el === document.activeElement) {
                        indexOfInputSelected = index;
                        break;
                    }
                }

                if (indexOfInputSelected !== undefined) {
                    if (indexOfInputSelected < inputElements.length - 1) {
                        inputElements[indexOfInputSelected + 1].focus();
                    } else {
                        inputElements[indexOfInputSelected].blur();
                    }
                }
            }
        } else if (
            this.props.store.getState().vpp.quickFillBoxChecked &&
            this.state.selectedInputElementId
        ) {
            if (button !== "OK") {
                let inputElement = document.getElementById(
                    this.state.selectedInputElementId
                );

                if (inputElement !== undefined && inputElement !== null) {
                    let inputValue = inputElement.value;
                    if (button === "{bksp}" && inputElement.value.length > 0) {
                        if (isLongTouch) {
                            inputValue = "";
                        } else {
                            inputValue = inputValue.substring(0, inputValue.length - 1);
                        }
                    } else if (
                        Number.isInteger(button) ||
                        (button === getDecimalSeparator(this.props.store) &&
                            !this.state.selectedInputElementId.includes("betmultiplierInput"))
                    ) {
                        // if(isLongTouch){
                        //   inputValue = button.toString();
                        // } else {
                        //   inputValue = inputValue + button;
                        // }
                        inputValue = inputValue + button;
                    } else if (button.charAt(0) === "+") {
                        //This is required for function keys, see Keyboard class
                        let systemLanguage = this.props.store.getState().vpp.systemLanguage;
                        inputValue = this.add(reverseFormatNumber(inputValue, systemLanguage), reverseFormatNumber(button, systemLanguage));
                    }
                    var currencyRegex =
                        "^\\" + getDecimalSeparator(this.props.store); //Regex Updated for bug PROD_VSB-6458
                    if (new RegExp(currencyRegex).test(inputValue)) {
                        inputValue = "0" + inputValue;
                    }

                    if (
                        button !== "{bksp}" &&
                        inputValue === getDecimalSeparator(this.props.store)
                    ) {
                        inputElement.value = inputValue;
                    } else if (
                        this.state.selectedInputElementId.includes("betmultiplierInput")
                    ) {
                        inputElement.value = inputValue;
                        this.props.store.dispatch(
                            updateOpenBetMultiplier(this.state.betFocused, inputValue)
                        );
                    } else {
                        let category = this.getCategoryForQuickFill();
                        if (isBetValid(inputValue, this.props.store, category)) {
                        inputElement.value = inputValue;
                        this.props.store.dispatch(
                            doQuickFillBets(
                                inputValue,
                                process.env.NODE_ENV !== "development" &&
                                BMS &&
                                BMS.authentication &&
                                BMS.authentication.isPlayerLogged &&
                                this.state.playerBalance
                                    ? this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                                    : 2,
                                this.props.store.getState().vpp.systemLanguage,
                                this.props.store.getState().vpp.systemCurrency));
                        }
                    }
                }
            } else {
                if (button === "OK" &&
                !OPERATOR.quickBetFillEnabled  && !OPERATOR.quickFillAutoFocusEnabled) {
                    this.props.store.dispatch(
                        toggleQuickFill(
                            !this.props.store.getState().vpp.quickFillBoxChecked
                        )
                    );
                }
                let inputElements = document.querySelectorAll(
                    'input[name="stakeInput"]:not([disabled])'
                );
                let indexOfInputSelected;

                for (const [index, el] of inputElements.entries()) {
                    if (el === document.activeElement) {
                        indexOfInputSelected = index;
                        break;
                    }
                }

                if (indexOfInputSelected !== undefined) {
                    if (indexOfInputSelected < inputElements.length - 1) {
                        inputElements[indexOfInputSelected + 1].focus();
                    } else {
                        inputElements[indexOfInputSelected].blur();
                    }
                }
            }
        }
    }

    add(inputValue, button) {
        inputValue =
            Number(inputValue) + Number(button.substring(1, button.length));
        inputValue = Math.round(inputValue * 100) / 100;
        return inputValue.toString();
    }
}

export default connect(mapStateToProps)(OpenBets);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/openBets.js